import { render, staticRenderFns } from "./FullLayout.vue?vue&type=template&id=44875e5f&scoped=true&"
import script from "./FullLayout.vue?vue&type=script&lang=js&"
export * from "./FullLayout.vue?vue&type=script&lang=js&"
import style0 from "./admin.scss?vue&type=style&index=0&id=44875e5f&lang=scss&scoped=true&"
import style1 from "./admin-additional.scss?vue&type=style&index=1&id=44875e5f&lang=scss&scoped=true&"
import style2 from "./FullLayout.vue?vue&type=style&index=2&lang=css&"
import style3 from "./FullLayout.vue?vue&type=style&index=3&id=44875e5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44875e5f",
  null
  
)

export default component.exports